import { ITagModel } from './tag.model';
import { translate } from '@jsverse/transloco';

export class TagModel implements ITagModel {
    prefix: string = '';
    name: string = '';
    value: string | undefined = '';
    tagValue: string = '';
    isNew: boolean = false;

    set displayPrefix(prefix) {
        this.prefix = prefix;
    }
    get displayPrefix(): string {
        if (this.prefix) {
            if (this.prefix === '/vc/') {
                return translate('CORE.INTERNAL');
            }
            if (this.prefix === '/pvt/') {
                return translate('CORE.PRIVATE');
            }
        }
        return translate('CORE.EXTERNAL');
    }

    set displayValue(value) {
        this.value = value;
    }
    get displayValue(): string {
        let val = this.name;
        if (this.value) {
            val = val.concat(' | ', this.value);
        }
        return val;
    }
}
